import React, { createContext, useContext, useEffect, useState, useCallback, ReactNode } from 'react';

type TitleContextType = {
  setTitle: (title: string) => void;
  resetTitle: () => void;
};

const TitleContext = createContext<TitleContextType>({
  setTitle: () => {},
  resetTitle: () => {},
});

export const TitleProvider = ({
  defaultTitle = 'TEST',
  children,
}: {
  defaultTitle?: string;
  children: ReactNode;
}) => {
  const [currentTitle, setCurrentTitle] = useState<string>(defaultTitle);

  useEffect(() => {
    document.title = currentTitle;
  }, [currentTitle]);

  const setTitle = useCallback((title: string) => {
    setCurrentTitle(title);
  }, []);

  const resetTitle = useCallback(() => {
    setCurrentTitle(defaultTitle);
  }, [defaultTitle]);

  return (
    <TitleContext.Provider value={{ setTitle, resetTitle }}>
      {children}
    </TitleContext.Provider>
  );
};

export const usePageTitle = () => useContext(TitleContext);